export default "__VITE_PUBLIC_ASSET__b4f669b3__"